import { render, staticRenderFns } from "./FacebookStatCosts.vue?vue&type=template&id=507e6ca6&"
import script from "./FacebookStatCosts.vue?vue&type=script&lang=js&"
export * from "./FacebookStatCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports